// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sUCt","largestCol":"styles_largestCol__3CE6n","smallestCol":"styles_smallestCol__3zuQ3"};